import React from "react";
import "./appsPrivacyPolicy.css";

import PolicyHeader from "./components/PolicyHeader";
import TableOfContents from "./components/TableOfContents";
import PolicyFooter from "./components/PolicyFooter";

import Overview from "./sections/Overview";
import InformationWeCollect from "./sections/InformationWeCollect";
import DeviceIdentifier from "./sections/DeviceIdentifier";
import DevicePermissions from "./sections/DevicePermissions";
import ThirdPartyServices from "./sections/ThirdPartyServices";
import PushNotifications from "./sections/PushNotifications";
import DataRetention from "./sections/DataRetention";
import ChildrensPrivacy from "./sections/ChildrensPrivacy";
import YourRights from "./sections/YourRights";
import PolicyChanges from "./sections/PolicyChanges";
import ContactUs from "./sections/ContactUs";

function AppsPrivacyPolicy() {
  return (
    <div className="apps-pp">
      <PolicyHeader />

      <main className="pp-main">
        <TableOfContents />

        <Overview />
        <InformationWeCollect />
        <DeviceIdentifier />
        <DevicePermissions />
        <ThirdPartyServices />
        <PushNotifications />
        <DataRetention />
        <ChildrensPrivacy />
        <YourRights />
        <PolicyChanges />
        <ContactUs />
      </main>

      <PolicyFooter />
    </div>
  );
}

export default AppsPrivacyPolicy;
